/** @format */
import { Injectable } from '@angular/core';
import { DowngradedService, ServiceDowngradeMappings, StaticMembers } from 'sis-common';
import { enrolmentQuestionnaireModalOpener } from './enrolment-questionnaire-modal.component';

/** A wrapper service which allows opening the new {@link EnrolmentQuestionnaireModalComponent} from AngularJS */
@StaticMembers<DowngradedService>()
@Injectable({ providedIn: 'root' })
export class EnrolmentQuestionnaireModalLegacyService {
    static downgrade: ServiceDowngradeMappings = {
        moduleName: 'sis-components.enrolment-questionnaire-modal-legacy-service',
        serviceName: 'enrolmentQuestionnaireModalLegacyService',
    };

    readonly open = enrolmentQuestionnaireModalOpener();
}
